import { createUserManager } from 'redux-oidc';
import { WebStorageStateStore } from 'oidc-client';
import { isLocalhost } from './isLocalhost';
//import { Log } from 'oidc-client';

import getConfiguration from './services/environment';

const baseUrl = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;

const userManagerConfig = (authority: string) => ({
    authority,
    automaticSilentRenew: true,
    monitorSession: !isLocalhost,
    client_id: 'di-internal-user-client-js',
    post_logout_redirect_uri: `${baseUrl}/logged-out`,
    redirect_uri: `${baseUrl}/callback.html`,
    response_type: 'id_token token',
    scope: 'openid profile email LocalAPI',
    silent_redirect_uri: `${baseUrl}/silent-renew.html`,
    userStore: new WebStorageStateStore({ store: window.localStorage })
});

const create = async () => {
    //Log.logger = console;
    //Log.level = Log.DEBUG;

    const configuration = await getConfiguration();
    const userManager = await createUserManager(userManagerConfig(configuration.diLoginAuthority));

    //userManager.events.addUserLoaded(() => console.log('DI: User loaded'));
    //userManager.events.addUserUnloaded(() => console.log('DI: User unloaded'));
    //userManager.events.addAccessTokenExpiring(() => console.log('DI: Access token expiring'));
    //userManager.events.addAccessTokenExpired(() => console.log('DI: Access token expired'));
    //userManager.events.addSilentRenewError(() => console.log('DI: Silent renew error'));
    //userManager.events.addUserSignedOut(() => console.log('DI: User signed out'));

    return userManager;
};

const userManagerPromise = create();

export default userManagerPromise;